import 'owl.carousel';
import vars from '../helpers';

let btn = null;
function addFirst() {
	const elements = vars.$document[0].querySelectorAll('.owl-item');
	const elementsActive = vars.$document[0].querySelectorAll('.owl-item.active');
	elements.forEach((item) => {
		item.classList.remove('is-first');
	});

	const first = elementsActive[0];
	first.classList.add("is-first");
}

function init() {
	return new Promise((resolve) => {
		const $carousel = vars.$document.find('.owl-carousel--js');
		$carousel.owlCarousel({
			autoplay: false,
			loop: true,
			margin: 0,
			nav: true,
			dots: false,
			autoWidth: true,
			navText: ['<svg class="icon icon-arrow-nav-prev"><use xlink:href="./images/sprites.svg#icon-arrow-nav-prev"></use></svg>', '<svg class="icon icon-arrow-nav-next"><use xlink:href="./images/sprites.svg#icon-arrow-nav-next"></use></svg>'],
			responsive: {
				0: {
					items: 1
				},
				1025: {
					items: 3
				},
				1800: {
					autoWidth: false,
				}
			},
			onDragged: addFirst
		});

		btn = vars.$document.find('button[class*="owl-"]');

		btn.on('click.btn', addFirst);
		addFirst();

		resolve();
	});
}

function destroy() {
	const $carousel = vars.$document.find('.owl-carousel--js');
	$carousel.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded owl-theme');
	$carousel.find('.owl-stage-outer').children().unwrap();
	if (btn) {
		btn.off('click.btn', addFirst);
	}
}

export default {
	init,
	destroy,
	addFirst
}
